export const toDDMMYYYYFromString = (inputDate) => {
  const dateValue = inputDate.split("T")?.[0] || inputDate;
  const splitDateFormat = dateValue.split("-");
  return splitDateFormat[2] + "-" + splitDateFormat[1] + "-" + splitDateFormat[0];
};

export const toDDMMYYYYFromDate = (inputDate) => {
  const localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const convertedDate = inputDate.toLocaleString("en-GB", {
    timeZone: localTimeZone
  });

  const splitDate = convertedDate?.split(",");
  if (splitDate.count === 0) {
    throw new Error("No valid date found for conversion");
  }

  const splitDateFormat = splitDate[0]?.split("/");
  if (splitDate.count === 0) {
    throw new Error("No valid date found for conversion");
  }

  const day = splitDateFormat[0];
  const month = splitDateFormat[1];
  const year = splitDateFormat[2];

  return day + "-" + month + "-" + year;
};
